import { Component } from 'react';
import PropTypes from 'prop-types';
import ThemeComponent from './ThemeComponent';
import { staticHypotheekbondUrl, CoreNumericInputComponent, hstatic } from '../../../index';

class PercentInputComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
  }

  onChangeHandler(e) {
    this.setState({ value: e.target.value });

    this.props.onChangeHandler(e);
  }

  onBlurHandler(e) {
    this.props.onBlurHandler(e);
  }

  render() {
    const {
      name,
      label,
      id,
      className,
      errors,
      readOnly,
    } = this.props;

    let inputClassNames = 'form-control';
    if (this.state.value !== null) {
      inputClassNames += ' has-content';
    }

    let classNames = 'input-field';
    if (className) {
      classNames += ` ${className}`;
    }

    return (
      <ThemeComponent
        label={label}
        className={classNames}
        errors={errors}
        id={id}
        postfixIcon={hstatic(`${staticHypotheekbondUrl()}images/icon/percent.svg`)}
      >
        <CoreNumericInputComponent
          name={name}
          id={id}
          onChangeHandler={this.onChangeHandler}
          onBlurHandler={this.onBlurHandler}
          value={this.state.value}
          className={inputClassNames}
          alwaysDecimals
          decimals={2}
          readOnly={readOnly}
        />
      </ThemeComponent>
    );
  }
}

PercentInputComponent.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
  onChangeHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  readOnly: PropTypes.bool,
};

PercentInputComponent.defaultProps = {
  className: null,
  value: null,
  name: null,
  onChangeHandler: () => {},
  onBlurHandler: () => {},
  errors: null,
};

export default PercentInputComponent;
